import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-content-end mt-5 pt-5",
  style: {"z-index":"999"}
}
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto",
  "data-bs-dismiss": "alert"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-1 text-primary" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.alert.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              style: {"width":"31%"},
              class: _normalizeClass(`
          alert alert-${_ctx.alert.variant}
          d-flex
          align-items-center
          p-5
          mb-10
          position-fixed
          mx-3
          respo-width
        `)
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(`svg-icon svg-icon-2hx svg-icon-${_ctx.alert.variant} me-4`)
              }, [
                _createVNode(_component_inline_svg, {
                  src: `media/icons/duotune/general/gen0${_ctx.alert.variant == 'primary' ? '48' : '50'}.svg`
                }, null, 8, ["src"])
              ], 2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", {
                  class: _normalizeClass(`mb-1 text-${_ctx.alert.variant}`)
                }, _toDisplayString(_ctx.alert.message), 3),
                _createElementVNode("span", null, _toDisplayString(_ctx.alert.subMessage), 1)
              ]),
              _hoisted_4
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}